import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Text } from '../components/base/Text';
import { useTheme } from '../hooks';

export const AboutScreen = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  useTheme();

  return (
    <div style={{ padding: 'var(--space-lg)' }}>
      <button
        type="button"
        onClick={() => navigate('/')}
        style={{ display: 'flex', alignItems: 'center', gap: 8, background: 'none', border: 'none', cursor: 'pointer', color: 'var(--color-accent)', marginBottom: 'var(--space-lg)' }}
      >
        <ArrowLeft size={20} /> {t('common.back', 'Back')}
      </button>
      <Text variant="display" as="h1" style={{ marginBottom: 'var(--space-lg)', color: 'var(--color-text-primary)' }}>
        {t('about.title')}
      </Text>
      <Text variant="body" style={{ lineHeight: 1.6, color: 'var(--color-text-primary)', whiteSpace: 'pre-line' }}>
        {t('about.description')}
      </Text>
      <div style={{ marginTop: 'var(--space-xl)', paddingTop: 'var(--space-lg)', borderTop: '1px solid var(--color-border)' }}>
        <Text variant="meta" muted>{t('about.version', { version: '1.0.0' })}</Text>
      </div>
    </div>
  );
};
